import { SimulationVariable } from '../simulation-variable';

export interface KpiProvider {
  getAvailableKpis(): Array<SimulationVariable>;
}

export function isKpiProvider(value: any): value is KpiProvider {
  return typeof value.getAvailableKpis === 'function';
}
